import { Fragment } from 'react';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import MoveToInbox from '../move-to-inbox/components/MoveToInbox';
// @ts-expect-error type not available yet
import MarkAsSpamPrompt from '../thread-toolbar/components/MarkAsSpamPrompt';
import { useThreadDetails } from '../thread-details-feature/public/hooks/useThreadDetails';
import UndoButton from '../alerts/components/UndoButton';
import AsyncBlockThreadPrompt from './async/AsyncBlockThreadPrompt';
import AsyncSendTranscriptPrompt from './async/AsyncSendTranscriptPrompt';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { MARK_AS_SPAM_MARKER } from '../performance-metrics/constants/performanceConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MoreActionsPrompts = ({
  inboxId,
  isKnownVisitor,
  isThreadFiltered,
  threadId,
  genericChannelId,
  visitorEmailAddress,
  properties,
  showBlockThreadPrompt,
  showSendTranscriptPrompt,
  showMoveToInboxPrompt,
  showMarkAsSpamPrompt,
  setBlockThreadPrompt,
  setHasBlockBeenClicked,
  setSendTranscriptPrompt,
  setMoveToInboxPrompt,
  setMarkAsSpamPrompt
}) => {
  const {
    markAsSpam,
    unmarkAsSpam
  } = useThreadDetails({
    threadId
  });
  const confirmBlockThread = () => {
    setBlockThreadPrompt(false);
    setHasBlockBeenClicked(true);
  };
  const renderBlockThreadPrompt = () => {
    if (!showBlockThreadPrompt) {
      return null;
    }
    return /*#__PURE__*/_jsx(AsyncBlockThreadPrompt, {
      isKnownVisitor: isKnownVisitor,
      onConfirm: confirmBlockThread,
      onReject: () => setBlockThreadPrompt(false),
      visitorEmailAddress: visitorEmailAddress,
      threadId: threadId,
      genericChannelId: genericChannelId
    });
  };
  const renderSendTranscriptPrompt = () => {
    if (!showSendTranscriptPrompt) {
      return null;
    }
    return /*#__PURE__*/_jsx(AsyncSendTranscriptPrompt, {
      inboxId: inboxId,
      threadId: threadId,
      onConfirm: () => setSendTranscriptPrompt(false),
      onReject: () => setSendTranscriptPrompt(false)
    });
  };
  const renderMoveToInboxPrompt = () => {
    if (!showMoveToInboxPrompt) {
      return null;
    }
    return /*#__PURE__*/_jsx(MoveToInbox, {
      onConfirm: () => setMoveToInboxPrompt(false),
      onReject: () => setMoveToInboxPrompt(false),
      properties: properties,
      isThreadFiltered: isThreadFiltered
    });
  };
  const onConfirmSpam = () => {
    performance.mark(`${MARK_AS_SPAM_MARKER}-start`);
    markAsSpam();
    FloatingAlertStore.addAlert({
      message: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-ui.alerts.marked-as-spam"
        }), /*#__PURE__*/_jsx(UndoButton, {
          onClick: unmarkAsSpam
        })]
      }),
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-ui.alerts.titles.success"
      }),
      type: 'success'
    });
    setMarkAsSpamPrompt(false);
  };
  const renderMarkAsSpamPrompt = () => {
    return showMarkAsSpamPrompt && /*#__PURE__*/_jsx(MarkAsSpamPrompt, {
      onConfirm: onConfirmSpam,
      onReject: () => {
        setMarkAsSpamPrompt(false);
      }
    });
  };
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [renderSendTranscriptPrompt(), renderBlockThreadPrompt(), renderMoveToInboxPrompt(), renderMarkAsSpamPrompt()]
  });
};
MoreActionsPrompts.displayName = 'MoreActionsPrompts';
export default MoreActionsPrompts;